module.exports = __webpack_public_path__ + "media/images/miami_02_tall-287f90eda29b23242f3298a1b385b334.jpg";